module.exports = __webpack_public_path__ + "static/media/iconLogo.4c5df4a2.svg";